import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import React, { useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from '@praxis/component-auth';
import { HelveticaForTarget } from '@enterprise-ui/component-font';
import { ToastProvider, Layout } from '@enterprise-ui/canvas-ui-react';
import '@enterprise-ui/canvas-ui-css';
import '@enterprise-ui/canvas-ui-css-autocomplete';
import ProtectedElement from '../ProtectedElement/ProtectedElement.js';
import AppRouter from './AppRouter.js';
import AppHeader from './AppHeader.js';
import AppSideNav from './AppSideNav.js';

var AppContainer = function AppContainer(_ref) {
  var appName = _ref.appName,
    authConfig = _ref.authConfig,
    baseADGroups = _ref.baseADGroups,
    navigationConfig = _ref.navigationConfig;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSideNavOpen = _useState2[0],
    setIsSideNavOpen = _useState2[1];
  var openSideNav = function openSideNav() {
    setIsSideNavOpen(true);
  };
  var closeSideNav = function closeSideNav() {
    setIsSideNavOpen(false);
  };
  return /*#__PURE__*/React.createElement(ToastProvider, {
    location: "top"
  }, /*#__PURE__*/React.createElement(HelveticaForTarget, {
    variants: ['n4', 'n5', 'n7']
  }), /*#__PURE__*/React.createElement(BrowserRouter, null, /*#__PURE__*/React.createElement(AuthProvider, authConfig, /*#__PURE__*/React.createElement(ProtectedElement, {
    allowed: baseADGroups
  }, /*#__PURE__*/React.createElement(Layout, {
    theme: "target" // configure theme here
    ,
    darkMode: "system" // configure dark mode here
    ,
    "data-testid": "mainAuthenticatedLayout",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(AppHeader, {
    appName: appName,
    onSideNavOpen: openSideNav
  }), /*#__PURE__*/React.createElement(AppSideNav, {
    appName: appName,
    sideNavItems: navigationConfig.sideNavItems,
    isVisible: isSideNavOpen,
    onRequestClose: closeSideNav
  }), /*#__PURE__*/React.createElement(Layout.Body, {
    includeRail: true,
    className: "topPage-layout-body"
  }, /*#__PURE__*/React.createElement(AppRouter, {
    routes: navigationConfig.routes
  })))))));
};

export { AppContainer as default };
